import { types as t, getParent, flow } from 'mobx-state-tree';

import { abbreviateDate } from '@utils/date';

import { Job } from 'models/jobs';
import { UserRef } from 'models/users';
import { withEnv } from 'models/withEnv';

export const JobNote = t
  .model('JobNote', {
    id: t.identifierNumber,
    job: t.maybe(t.reference(t.late(() => Job))),
    user: t.maybe(t.late(() => UserRef)),
    dateCreated: t.maybe(t.string),
    text: t.maybe(t.string),
    isAdminNote: t.maybe(t.boolean),

    isEditing: false,
  })
  .views(withEnv)
  .actions((self) => ({
    edit() {
      self.isEditing = true;
    },
    remove() {
      return self.parent.removeNote(self);
    },
    update: flow(function* (text) {
      const res = yield self.env.api.jobs.editNote(self.id, { text });
      if (!res.error) {
        self.text = text;
        self.env.showSuccess(self.env.t('job.info.notes.update.success'));
        return true;
      } else {
        self.env.showError(self.env.t('job.info.notes.update.error'));
        return false;
      }
    }),
  }))
  .views((self) => ({
    get dateDisplay() {
      const name = self.user.displayName;
      const date = abbreviateDate(self.dateCreated, self.env.lang, 'datetime');
      return `${name} • ${date}`;
    },
    get parent() {
      return getParent(self, 2);
    },
  }));
